import React, { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { XIcon } from "@heroicons/react/outline";
import Button from "./Button";

const Drawer = ({ 
  isOpen, 
  onClose, 
  title, 
  children, 
  size = "md",
  position = "right" 
}) => {
  const sizeClasses = {
    sm: "max-w-sm",
    md: "max-w-md",
    lg: "max-w-lg",
    xl: "max-w-xl",
    full: "max-w-full",
  };

  const positionClasses = {
    left: "left-0",
    right: "right-0",
  };

  return (
    <Transition.Root show={isOpen} as={Fragment}>
      <Dialog 
        as="div" 
        className="relative z-50" 
        onClose={onClose}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-in-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in-out duration-300"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black bg-opacity-50 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-hidden">
          <div className="absolute inset-0 overflow-hidden">
            <div className={`pointer-events-none fixed inset-y-0 ${positionClasses[position]} flex ${sizeClasses[size]} pl-10`}>
              <Transition.Child
                as={Fragment}
                enter="transform transition ease-in-out duration-300"
                enterFrom={`${position === 'right' ? 'translate-x-full' : '-translate-x-full'}`}
                enterTo="translate-x-0"
                leave="transform transition ease-in-out duration-300"
                leaveFrom="translate-x-0"
                leaveTo={`${position === 'right' ? 'translate-x-full' : '-translate-x-full'}`}
              >
                <Dialog.Panel className="pointer-events-auto relative w-screen max-w-full">
                  <div className="flex h-full flex-col overflow-y-scroll bg-background dark:bg-glass-dark shadow-xl">
                    {/* Header */}
                    <div className="px-6 py-4 border-b border-neutral-light dark:border-neutral-dark">
                      <div className="flex items-center justify-between">
                        <Dialog.Title className="text-lg font-semibold text-text dark:text-neutral-light">
                          {title}
                        </Dialog.Title>
                        <button
                          type="button"
                          className="rounded-md text-neutral-dark hover:text-text dark:text-neutral-light dark:hover:text-white focus:outline-none focus:ring-2 focus:ring-primary"
                          onClick={onClose}
                        >
                          <span className="sr-only">Close panel</span>
                          <XIcon className="h-6 w-6" aria-hidden="true" />
                        </button>
                      </div>
                    </div>

                    {/* Content */}
                    <div className="relative flex-1 px-6 py-4">
                      {children}
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
};

export default Drawer;
